import { useEffect, useState } from "react";

import BlogListItem from "../models/item.interface";
import BlogListState from "../models/state.interface";
import shuffle from "../helpers/shuffle";

import { useHistory, useLocation } from "react-router-dom";
import fetchContentByType from "app/umbraco/helpers/fetchContentByType";

export default (tags?: string[]): any => {
    const history = useHistory();
    const location = useLocation<BlogListState>();

    const initialItems = location.state?.posts;
    const [items, setItems] = useState<BlogListItem[]>(initialItems);

    const [viewState, setViewState] = useState<string>(initialItems?.length > 0 ? "LOADED" : "LOADING");

    useEffect(() => {
        let isComponentMounted = true;

        const fetchBlogPosts = async () => {
            let result: BlogListItem[] = [];
            const response = await fetchContentByType<BlogListItem[]>("blogPage", history.location.pathname);

            // Filter
            if (response && response.length > 0) {
                const eligibleBlogPosts = response.filter(x => {
                    if (tags && tags.length > 0) {
                        const itemHasMatchTag = tags.some(tag => x.tags && x.tags.includes(tag))
                        return itemHasMatchTag;
                    }
                });

                result = eligibleBlogPosts;
            }

            // Sorting
            if (result && result.length > 0) {
                result = shuffle(result);
            }

            if (isComponentMounted) {
                setItems(result);
                
                history.replace(location.pathname, {
                    ...location.state,
                    posts: result
                });

                return result;
            }
        };

        const setFetching = fetchBlogPosts();
        const setLoading = new Promise((resolve) => { setTimeout(resolve, 1000); });

        Promise.all([setFetching, setLoading]).then((values) => {
            const result = values?.[0];

            if (result && result.length > 0) {
                setViewState("LOADED");
            } else {
                setViewState("EMPTY");
            }
        }).catch(() => {
            setViewState("ERROR");
        });

        return () => {
            isComponentMounted = false;
        };
    }, []);

    return {items, viewState};
};